<template>
  <layout name="Auth" title="Welcome Back!">
    <VCardBox>
      <template slot="left-side">
        <div class="ink-login__main-wrapper--form">
          <h4>Sign In</h4>

          <LoginForm></LoginForm>

          <div class="additional-block">
            <span>
              or
            </span>
            <VButton
              label="Request a Demo"
              type=""
              extraClass="request-demo-short"
              @click="() => externalBlank('https://inkit.io/demo/')"
            ></VButton>
          </div>
        </div>

        <div class="ink-login__main-wrapper--forgot-wrapper">
          <span> Trouble signing in? </span>
          <hr />

          <VLink
            type="primary"
            routerLink="/forgot-password"
            label="Forgot my password"
          ></VLink>
        </div>
      </template>

      <template slot="right-side">
        <div class="ink-login__main-wrapper--right__text">
          <img :src="LoginLogo" alt="logo" />

          <h3>
            Looking to <br />
            integrate mail <br />
            with your favorite <br />
            apps and CRM?
          </h3>

          <VButton
            label="Request a Demo"
            extraClass="auth-request-demo"
            type=""
            @click="() => externalBlank('https://inkit.io/demo/')"
          ></VButton>
        </div>
      </template>
    </VCardBox>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";

import withNavigate from "@/mixins/withNavigate";

import VLink from "@/components/VLink";
import VButton from "@/components/VButton";
import LoginForm from "@/components/LoginForm";
import VCardBox from "@/components/VCardBox";

import CampaignLogo from "@/assets/images/campaign_logo.svg";
import LoginLogo from "@/assets/images/login_logo.svg";

export default Vue.component("Login", {
  metaInfo: {
    title: "Login"
  },

  data() {
    return {
      CampaignLogo,
      LoginLogo
    };
  },

  components: {
    VLink,
    Layout,
    LoginForm,
    VButton,
    VCardBox
  },

  mixins: [withNavigate]
});
</script>

<style lang="scss" scoped>
$ns: "ink-login";

.#{$ns} {
  &__main-wrapper {
    &--form {
      margin-top: 10%;

      h4 {
        font-size: 20px;
        margin-bottom: 15px;
      }

      /deep/ .input-icon__wrapper.left {
        /*height: 40px;*/
      }

      .additional-block {
        display: none;

        > span {
          display: block;
          margin: 15px 0;
          text-align: center;
        }

        button {
          margin: 0;
          background: transparent;
          color: $primary-color;
          transition: all 0.15s linear;
          border-radius: 40px;
          border: 1px solid $primary-color;
          padding: 6px 15px;
          cursor: pointer;
          width: 100%;
          font-size: 14px;

          &:hover {
            background: $primary-color;
            color: $white;
          }
        }
      }
    }

    &--right {
      &__text {
        position: relative;
        z-index: 3;
        height: 100%;
        padding: 30px;

        img {
          width: 70px;
        }

        h3 {
          color: #fff;
          font-size: 32px;
          line-height: 1.2;
          margin: 45px 0 40px;
          font-family: Lato-Light, Arial, sans-serif;
        }

        button {
          border-radius: 40px;
          background: transparent;
          border: 1px solid $white;
          color: $white;
          padding: 6px 15px;
          font-size: 13px;
          font-family: Lato-Light, Arial, sans-serif;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .#{$ns} {
    &__main-wrapper {
      &--form {
        margin-top: 0;

        .additional-block {
          display: block;
        }
      }
    }
  }
}
</style>

<style lang="scss">
button.auth-request-demo {
  transition: all 0.15s linear;
  height: $input-height;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    color: $primary-color;
  }
}

button.auth-request-demo-short {
  transition: all 0.15s linear;
  border-radius: 40px;
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 6px 15px;
  font-size: 13px;
  font-family: Lato-Light, Arial, sans-serif;
  cursor: pointer;
}

.loginLoader {
  height: 500px;
}
</style>
